var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{staticClass:"col-span-8"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }